import { render, staticRenderFns } from "./CkditorCoreCourse.vue?vue&type=template&id=704cd7a8"
import script from "./CkditorCoreCourse.vue?vue&type=script&lang=js"
export * from "./CkditorCoreCourse.vue?vue&type=script&lang=js"
import style0 from "./CkditorCoreCourse.vue?vue&type=style&index=0&id=704cd7a8&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports